import {
  getFileFromImage,
  GptImageVersion,
  ImageSettings,
  ImageSuiteAppProps,
  MetaData,
  ModelImageFXModelName,
  ModelImageFXName,
  ModelWhiskModelName,
} from "../../../../Helper";
import { Box, Modal, Typography } from "@mui/material";
import { InputText } from "../Shared/InputText";
import { SuiteAppSettings } from "../Shared/SuiteAppSettings";
import { AppActionButton } from "../Shared/AppActionButton";
import { OutputImage } from "../Shared/OutputImage";
import "../../../SharedSuite/Suites.css";
import SignalRService from "../../../one-query/services/SignalRService";
import { useImageSuiteImageToImage } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {
  appContainerStyle,
  appInputOutputContainerStyle,
} from "../Shared/styles";
import ImageSelected from "../Shared/ImageSelected";
import ImagSelectionModal from "../Shared/ImagSelectionModal";

export const ImageToImageApp = ({
  example,
  imageSettings,
  handelGenerateRandomPrompt,
  IsGeneratePromptLoading,
  isGenerateButtonDisabled,
  generatedPrompt,
  generatedImg,
  isGenerateImgLoading,
  selectedModel,
  selectedSize,
  seed,
  setSelectedModel,
  setSelectedSize,
  getErrorMessage,
  toggleLockSeed,
  openLockSeed,
  inputValue,
  setInputValue,
  handleOpenExpandImage,
  handleSetIsLoading,
  inputImageValue,
  handleClearInput,
  handleInputImageChange,
  handelImprovePrompt,
  isImagePromptImproving,
  creditsNeeded,
}: ImageSuiteAppProps) => {
  const appSuiteCosts = useAppSelector((s) => s.User.AppSuiteCosts);
  const {
    mutate: GenerateImageToImageRequest,
    isPending: IsGenerateImageToImageLoading,
    error,
  } = useImageSuiteImageToImage();
  const dispatch = useAppDispatch();
  const [exampleMetaData, setExampleMetaData] = useState<MetaData>({});
  const [openSelectionImageModal, setOpenSelectionImageModal] = useState(false);
  const [imageSelected, setImageSelected] = useState<File | string | null>(
    null
  );

  useEffect(() => {
    let metaData = JSON.parse(example?.metaData || "{}");
    if (metaData) {
      setExampleMetaData(metaData);
    }
  }, [example]);

  useEffect(() => {
    if (IsGenerateImageToImageLoading) {
      handleSetIsLoading(true);
    }
  }, [IsGenerateImageToImageLoading]);

  useEffect(() => {
    if (error) getErrorMessage(error);
  }, [error]);

  const filteredSettings: ImageSettings | undefined = useMemo(() => {
  if (!imageSettings) return undefined;

  const filtered = {
    ...imageSettings,
    imageModels: imageSettings.imageModels
      .filter(
        (model) =>
          model.modelVersion === GptImageVersion ||
          model.modelVersion === ModelImageFXName
      )
      .map((model) =>
        model.modelName === ModelImageFXModelName
          ? { ...model, modelName: ModelWhiskModelName }
          : model
      ),
  };

  return filtered;
}, [imageSettings]);

useEffect(() => {
  if (!selectedModel && 
    filteredSettings?.imageModels?.length &&
    filteredSettings.imageModels[0].modelVersion
  ) {
    handleSelectModel(filteredSettings.imageModels[0].modelVersion);
  }
}, [filteredSettings]);

  const handleGenerateImage = async (
    inputValue: string,
    imageValue: File | string
  ) => {
    if (inputValue && inputValue?.trim() !== "") {
      const connectionId = await SignalRService.getInstance().getConnectionId();
      const isImageFile = imageValue instanceof File;
      console.log("imageValue>>", imageValue);
      const RequestData = {
        prompt: inputValue,
        connectionId: connectionId,
        image: isImageFile ? imageValue : null,
        imageUrl: isImageFile ? undefined : imageValue,
        modelName: selectedModel
        // seed:!openLockSeed?seed:null
      };
      GenerateImageToImageRequest(RequestData);
    }
  };

  const handleGenerationAction = () => {
    if (inputValue && inputImageValue) {
      handleGenerateImage(inputValue, inputImageValue);
    }
  };
  const handleSelectImage = async (image: File | string | null) => {
    setImageSelected(image);
  };
  const handleSelectModel = (model: string) => {
    setSelectedModel(model);
  };

  const handleSelectSize = (size: string) => {
    setSelectedSize(size);
  };

  useEffect(() => {
    if (!imageSelected) {
      return;
    }
    handleInputImageChange?.(imageSelected);
  }, [imageSelected]);

  return (
    <Box sx={appContainerStyle}>
      <Box className="image-suites-input-header">
        <Typography className="image-suites-input-header-title long-header-app">
          Enhance and transform your photos instantly
        </Typography>
      </Box>
      <Box sx={appInputOutputContainerStyle}>
        <Box className="image-suites-input">
          <Box className="image-suites-input-failed">
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "var(--Main_icons_color)",
                opacity: 0.7,
              }}
            >
              Your image
            </Typography>
            <ImageSelected
              imageSelected={
                inputImageValue
                  ? inputImageValue
                  : imageSelected
                    ? imageSelected
                    : exampleMetaData?.before
              }
              handleOpenSelectionImageModal={() =>
                setOpenSelectionImageModal(true)
              }
              isGenerateImgLoading={isGenerateImgLoading}
            />
            <Typography className="settings-title">Prompt</Typography>
            <InputText
              example={example}
              setInputValue={setInputValue}
              inputValue={inputValue}
              handelGenerateRandomPrompt={handelGenerateRandomPrompt}
              IsGeneratePromptLoading={IsGeneratePromptLoading}
              isGenerateImgLoading={isGenerateImgLoading}
              generatedPrompt={generatedPrompt}
              showRandomPromptBtn={false}
              handelImprovePrompt={handelImprovePrompt}
              isImprovePromptDisabled={isImagePromptImproving}
            />
          </Box>
          <SuiteAppSettings
            imageSettings={filteredSettings}
            handleSelectModel={handleSelectModel}
            handleSelectSize={handleSelectSize}
            selectedModel={selectedModel}
            selectedSize={selectedSize}
            toggleLockSeed={toggleLockSeed}
            openLockSeed={openLockSeed}
            seedValue={seed}
            showSetting={{ models: true, dimensions: false, seed: false }}
          />
          <AppActionButton
            creditsCount={creditsNeeded ?? 0}
            appMethodFire={handleGenerationAction}
            isGenerateButtonDisabled={isGenerateButtonDisabled}
            IsGeneratePromptLoading={IsGeneratePromptLoading}
            inputValue={inputValue}
          />
        </Box>
        <Box className="image-suites-output">
          <Box className="image-suites-output-result">
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Typography className="image-suites-output-result-placeholder">
                {isGenerateImgLoading || generatedImg
                  ? "Output"
                  : "Sample Output"}
              </Typography>
              <OutputImage
                slider={true}
                outputImage={true}
                imgUrl={generatedImg}
                isLoading={isGenerateImgLoading}
                handleOpenExpandImage={handleOpenExpandImage}
                sliderData={{
                  beforeImage: exampleMetaData?.before || "",
                  afterImage: exampleMetaData?.after || "",
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {openSelectionImageModal && (
        <Modal
          open={openSelectionImageModal}
          onClose={() => setOpenSelectionImageModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ImagSelectionModal
            handleClose={() => setOpenSelectionImageModal(false)}
            setImageSelected={handleSelectImage}
          />
        </Modal>
      )}
    </Box>
  );
};
